import path from 'path';
import babelPluginDynamicImportSyntax from '@babel/plugin-syntax-dynamic-import';
import babelPluginImportMetaSyntax from '@babel/plugin-syntax-import-meta';
import babelPresetEnv from '@babel/preset-env';
import babelPluginDynamicImport from 'babel-plugin-dynamic-import-node-babel-7';
import builtinModules from 'builtin-modules';
import json from '@rollup/plugin-json';
import babel from '@rollup/plugin-babel';
export { manifest, beforeJob } from '@pika/plugin-build-node';
import { rollup } from 'rollup';
const DEFAULT_MIN_NODE_VERSION = '8';
function processPlugins(plugins) {
    if (!plugins) {
        return [];
    }
    return plugins.map((plugin) => {
        let m;
        if (typeof plugin === 'string') {
            m = require(plugin)();
        }
        else if (Array.isArray(plugin) && plugin.length === 2) {
            m = require(plugin[0])(plugin[1]);
        }
        else {
            throw new Error('Expected string or config array (i.e. ["name", {/* config*/ }])');
        }
        return m;
    });
}
export async function build({ out, reporter, options = {} }) {
    const writeToNode = path.join(out, 'dist-node', 'index.js');
    const plugins = processPlugins(options.plugins);
    try {
        const result = await rollup({
            input: path.join(out, 'dist-src/index.js'),
            external: builtinModules,
            plugins: [
                json({
                    compact: true,
                    ...options.jsonConfig,
                }),
                babel({
                    babelrc: false,
                    compact: false,
                    presets: [
                        [
                            babelPresetEnv,
                            {
                                modules: false,
                                targets: {
                                    node: options.minNodeVersion || DEFAULT_MIN_NODE_VERSION,
                                },
                                spec: true,
                            },
                        ],
                    ],
                    plugins: [
                        babelPluginDynamicImport,
                        babelPluginDynamicImportSyntax,
                        babelPluginImportMetaSyntax,
                    ],
                }),
                ...plugins,
            ],
            onwarn: (warning, defaultOnWarnHandler) => {
                // Unresolved external imports are expected
                if (warning.code === 'UNRESOLVED_IMPORT' &&
                    !(warning.source.startsWith('./') || warning.source.startsWith('../'))) {
                    return;
                }
                defaultOnWarnHandler(warning);
            },
        });
        await result.write({
            file: writeToNode,
            format: 'cjs',
            exports: 'named',
            sourcemap: options.sourcemap === undefined ? true : options.sourcemap,
        });
        reporter.created(writeToNode, 'main');
    }
    catch (e) {
        if (options.debug) {
            console.error(options.debug === 'trace' ? e : e.message);
        }
        process.exit(1);
    }
}
